import axios, { AxiosResponse, AxiosError } from 'axios'
import moment from 'moment'
const requestTimeout = 5 * 60 * 1000

const errorData: { [key: string]: string } = {
    'invalid body': '',
    'user not exists': '',
    'invalid password': '',
    'password retry out of limit': '',
    'code used': '验证码已经失效，请重新发送',
    'code error': '验证码错误，请重新输入',
    'code expired': '验证码已经失效，请重新发送',
    'user not found': '该用户不存在，请检查手机号码是否正确',
    'not have a verifycode': '验证码错误，请重新输入',
    'channel exist': '该渠道手机号已存在',
    'channel user exist': '您已领取过该福利。'
}

export class ShareAPI {
    static base_path = '/api/admin/share'
    static listConfig(page = 1, pagesize = 10) {
        return get<PageResult<ShareConfig>>(`${this.base_path}/config`, { page, pagesize }).then(res => res.data)
    }
    static saveConfig(config: Partial<ShareConfig>) {
        return post(`${this.base_path}/config`, config)
    }
    static getConfig(type: string, key?: string | number) {
        return get<ShareConfig>(`${this.base_path}/config/${type}`, { key }).then(res => res.data)
    }
    static listReward(startDate?: Date, endDate?: Date) {
        let params = {}
        if (startDate && endDate && startDate.getTime() != endDate.getTime()) {
            params = {
                start: startDate.getTime(),
                end: endDate.getTime() + 24 * 60 * 60 * 1000
            }
        }
        return get<any>(`${this.base_path}/reward`, params).then(res => res.data)
    }
    static exportReward(startDate?: Date, endDate?: Date) {
        let params = {}
        if (startDate && endDate && startDate.getTime() != endDate.getTime()) {
            params = {
                start: startDate.getTime(),
                end: endDate.getTime() + 24 * 60 * 60 * 1000
            }
        }
        return post(`${this.base_path}/reward/export`, params).then(res => res.data)
    }
}

export class PushAPI {
    static base_path = '/api/admin/push'
    static create(title: string, content: string, type: string, pushContent: any, range: any) {
        return post(`${this.base_path}`, {
            title,
            content,
            pushContent,
            pushType: type,
            pushRange: range
        }).then(res => res.data)
    }
    static list() {
        return get<any[]>(`${this.base_path}`, {}).then(res => res.data)
    }
}

export class CoachCampAPI {
    static base_path = '/api/admin/coach-camp'
    static coach_path = '/api/coach/coach-camp'
    static create(coachCamp: CoachCamp) {
        return post(`${this.base_path}`, coachCamp).then(res => {
            return res.data
        })
    }
    static update(id: string | number, coachCamp: {}) {
        return put(`${this.base_path}/${id}`, coachCamp).then(res => {
            return res.data
        })
    }

    static list() {
        return get<{ data: CoachCamp[] }>(`${this.base_path}`).then(res => {
            return res.data
        })
    }

    static get(id: string | number) {
        return get<CoachCamp>(`${this.base_path}/${id}`).then(res => {
            return res.data
        })
    }

    static listEnrollmentsByCampId(id: string | number) {
        return get(`${this.base_path}/${id}/enrollments`).then(res => {
            return res.data
        })
    }

    static listForCoach() {
        return get<CoachCamp[]>(`${this.coach_path}`).then(res => {
            return res.data
        })
    }
}

export class ClientAPI {
    static base_path = '/api/admin/client'
    static coach_base_path = '/api/coach/client'

    static list(page: number = 0, pagesize: number = 10, type?: number, search?: string) {
        return get(`${this.base_path}`, { page, pagesize, type, search }).then(res => res.data)
    }

    static listCoachingOrders(userId: string, orderType?: number) {
        return get(`${this.base_path}/${userId}/coaching-orders`, { type: orderType }).then(res => res.data)
    }

    static getVersion(userId: string) {
        return get(`${this.coach_base_path}/${userId}/ver`).then(res => res.data)
    }

    static getDetail(userId: number) {
        return get<{
            profiles: ClientProfiles,
            initialInterviews: InitialInterview[],
            coachings: Coaching[],
            groupCoacningOrders: any[],
            courses: Course[],
            coachCamps: CoachCamp[]
        }>(`${this.coach_base_path}/${userId}`).then(res => res.data)
    }
}

export class VodAPI {
    static basePath = '/api/admin/vod'

    static getSignature() {
        return get<{
            data: {
                signature: string
            }
        }>(`${this.basePath}/signature`).then(res => res.data)
    }
}

export const login = () => {
    return get<string>('/api/admin/login')
}

export const signin = (mobile: string, nationalCode: string, vcode: string) => {
    return post('/api/admin/signin')
}

export const listOrder = () => {
    return get('/api/admin/order/list')
}

export const listCourse = (status?: string | undefined, type?: string | undefined) => {
    return get<Course[]>('/api/admin/course/list', { status, type }).then(res => res.data)
}

export const setCourseStatus = (status: string, courseId: string) => {
    return post('/api/admin/course/status', { status, courseId })
}

export const finishOrder = (orderNO: string) => {
    return post('/api/admin/order/finish', { orderno: orderNO })
}

export const setUserMembership = (level: string, time: string, userId: string) => {
    return post('/api/admin/client/setmembership', { level, time, userId })
}

export const listNotes = () => {
    return get('/api/coach/notes')
}

export const getTodoTasks = () => {
    return get('/api/coach/todotasks')
}

export const getQSTemplate = () => {
    return get('/api/coach/questionnairesurveytemplates')
}

export const getClientProfiles = (id: string) => {
    return get<any>('/api/coach/getclientprofiles', { id })
}

export const getCoaching = (id: string) => {
    return get<any>('/api/coach/getcoaching', { id: id })
}

export const saveCoachingNotes = (coachingId: string | null, content: string, clientId: string) => {
    return post('/api/coach/savecoachingnotes', { coachingId, content, clientId })
}

export const saveTheInitialInterview = (id: string, clientId: string, survey: string, submit: number) => {
    return post('/api/coach/savetheinitialinterview', { survey, clientId, id, submit })
}

export const getTheInitialInterview = (id: string) => {
    return get('/api/coach/gettheinitialinterview', { id })
}

export const saveCoachingSessions = (id: string, level: number, reviews: string, material: string, goals: string, nextWeeklyObjectives: WeeklyObjectives[], lastWeeklyObjectives: WeeklyObjectives[], weeklyCheckDate: number | undefined, interviewDate: number | undefined, hinderAndMeasures: string) => {
    return post('/api/coach/savecoachingsession', { id, level, reviews, material, goals, nextObjectives: nextWeeklyObjectives, lastObjectives: lastWeeklyObjectives, weeklyCheckDate, interviewDate, hinderAndMeasures })
}

export const importUserByExcel = (filepath: string) => {
    return post('/api/admin/client/import', { filepath })
}

export const allocInitialInterviewCoach = (id: string, coachId: string | null, appointmentTime: number | null) => {
    return post('/api/admin/initialinterview/alloccoach', { id, coachId, appointmentTime })
}

export const listInitialInterviews = (status?: 'create' | 'finish') => {
    return get('/api/admin/initialinterview/list', { status }).then(res => res.data)
}

export const listCoachInitialInterviews = (status?: 'create' | 'finish') => {
    return get('/api/coach/initialinterview/list', { status }).then(res => res.data)
}

export const listCoachCoachings = () => {
    return get('/api/coach/coaching/list').then(res => res.data)
}

export const listCoach = (type?: 'initial_interview' | 'one_on_one_coaching' | 'group_coaching') => {
    return get<Coach[]>('/api/coach/list', { type }).then(res => res.data)
}

export const getSts = () => {
    return post('/api/cos/sts', {}).then(res => res.data)
}

export const listTag = () => {
    return get<Tag[]>('/api/admin/tag/list', {}).then(res => res.data)
}

export const addTag = (name: string) => {
    return post('/api/admin/tag/add', { name }).then(res => res.data)
}

export const saveCourse = (course: Course, tids: string[]) => {
    return post('/api/admin/course/save', { ...course, tids })
}

export const saveCollection = (collection: CourseCollection) => {
    return post('/api/admin/collection/save', { ...collection })
}

export const getCourse = (id: string) => {
    return get(`/api/admin/course/${id}`)
}

export const getCollection = (id: string) => {
    return get(`/api/admin/collection/${id}`)
}

export const getIndexData = () => {
    return get('/api/admin/index/data').then(res => res.data)
}

export const getCourseCollection = () => {
    return get<CourseCollection[]>('/api/admin/course/collection').then(res => res.data)
}

export const listCourseForSort = (category?: number) => {
    return get('/api/admin/course/listforsort', { category }).then(res => res.data)
}

export const setCourseSort = (sort?: number, collection_sort?: number, course_id?: string, collection_id?: string) => {
    return post('/api/admin/course/setsort', { sort, collection_sort, course_id, collection_id }).then(res => res.data)
}

export const createCoaching = (name: string, mobile: string, nationalCode: string, number: string, coachId: string) => {
    return post('/api/admin/coaching/add', { name, mobile, nationalCode, number, coachId })
}

export const addChannel = (name: string, remark: string, presentCoin: number, displayName: string, mobile: string, nationalCode: string) => {
    return post('/api/admin/channel/add', { name, remark, presentCoin, mobile, nationalCode, displayName })
}

export const pushCourse = (id: string, type: string, title: string, content: string) => {
    return post('/api/admin/course/push', { id, type, title, content })
}

export const giveCourse = (userId: string, courseId: string, type: string) => {
    return post('/api/admin/course/give', { userId, courseId, type })
}

export const saveCoach = (coach: Coach) => {
    return post('/api/admin/coach/save', { ...coach })
}

export const updateChannel = (id: number, name: string, remark: string, presentCoin: number, displayName: string) => {
    return post('/api/admin/channel/update', { id, name, remark, presentCoin, displayName })
}

export const listChannel = () => {
    return get('/api/admin/channel/list', {}).then(res => res.data)
}

export const listChannelUser = (id?: number) => {
    return get('/api/admin/channel/users', { id }).then(res => res.data)
}

export const listChannelReports = (id?: number) => {
    return get('/api/admin/channel/reports', { id }).then(res => res.data)
}

export const listChannelRank = (m: string, type: 'internal' | 'external') => {
    return get('/api/admin/channel/rank', { m, type }).then(res => res.data)
}

export const getErrorMessage = (res: AxiosResponse) => {
    let errorMsg = errorData[res.data]
    if (!errorMsg) {
        return '请求错误，请重试'
    }
    return errorMsg
}

export const updateChannelVisit = (channelId: string) => {
    return post('/api/channel/visit', { channelId })
}

export const channelSignIn = (mobile: string, nationalCode: string, code: string) => {
    return post('/api/channel/signin', { mobile, nationalCode, code })
}

export const sendChannelVerifyCode = (mobile: string, nationalCode: string, type: number) => {
    return post('/api/channel/sendvcode', { mobile, nationalCode, type })
}

export const channelGetInfo = () => {
    return get('/api/channel/info', {}).then(res => res.data)
}

export const checkMobile = async (mobile: string, nationalCode: string = '86') => {
    return post('/api/client/checkmobile', { mobile, nationalCode }).then(res => res.data)
}

export const channelRegister = async (mobile: string, nationalCode: string, code: string, channelId: string) => {
    return post('/api/channel/register', { mobile, nationalCode, code, channelId })
}

export const channelRegister2 = async (mobile: string, nationalCode: string, channelId: string) => {
    return post('/api/channel/register2', { mobile, nationalCode, channelId })
}

export const getChannelDisplayInfo = async (channelId: string) => {
    return get('/api/channel/displayinfo', { channelId })
}

const handleRequestError = (error: AxiosError) => {
    let msg = '请求错误，请重试'
    if (error.response) {
        msg = getErrorMessage(error.response)
    }
    return Promise.reject({ msg, error })
}

const get = <T>(path: string, params = {}): Promise<AxiosResponse<T>> => {
    const headers = {

    }
    return axios.get(`${path}`, { timeout: requestTimeout, headers, params })
        .then(res => {
            return res;
        })
        .catch(handleRequestError);
}

const post = (path: string, params = {}): Promise<AxiosResponse> => {
    const headers = {

    }
    return axios.post(`${path}`, params, { timeout: requestTimeout, headers })
        .then(res => {
            return res;
        })
        .catch(handleRequestError);
}

const put = (path: string, params = {}): Promise<AxiosResponse> => {
    const headers = {

    }
    return axios.put(`${path}`, params, { timeout: requestTimeout, headers })
        .then(res => {
            return res;
        })
        .catch(handleRequestError);
}


